import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import type { IAccessMap } from '@shared/services/user.service';

/** True when the cached `/iam/me/access` result grants `permission` at the top level. Organization and account permissions do not count, so this cannot use the flattened `UserPermissionsService`. A missing or unparsable access map means no permission. */
export function hasTopLevelPermission(permission: string): boolean {
	try {
		const accessMap = JSON.parse(sessionStorage.getItem('User.AccessMap')) as IAccessMap | null;
		return Array.isArray(accessMap?.permissions) && accessMap.permissions.includes(permission);
	} catch {
		return false;
	}
}

/** Like `PermissionGuard`, but the route's `data.permission` must be granted at the top level. */
export const TopLevelPermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
	if (hasTopLevelPermission(route.data['permission'] as string)) return true;

	sessionStorage.setItem('Link.Illegal', 'x');
	return inject(Router).parseUrl('/core');
};
